<template>
    <div class="page-full-height">
      <loading v-if="loading"></loading>
      <div class="m-container" v-else>
        <h1 class="about-header">About US</h1>

        <div v-html="data.about" class="mb-20">

        </div>
      </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading/loading";
export default {
  name: "AboutUs",
  components: {Loading},
  data() {
    return {
      data: null,
      loading: true
    }
  },
  mounted() {
    this.$API.general.about()
    .then(response => {
      this.data = response;
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  }
}
</script>

<style scoped>
.about-header {
  font-size: 48px;
  line-height: 1;
  text-align: center;
}

.page-full-height {
  height: calc(100vh - 290px);;
}
</style>